module.exports = __webpack_public_path__ + "img/9012891710.af337885.png";